<script setup>
import { useRouteLoading } from "@/composables/useRouteLoading";

const { progress, isVisible } = useRouteLoading();
</script>

<template>
  <Transition name="route-loading-fade">
    <div
      v-if="isVisible"
      class="route-loading-bar"
      role="progressbar"
      aria-label="Page loading"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-valuenow="Math.round(progress * 100)"
    >
      <div class="indicator" :style="{ transform: `scaleX(${progress})` }" />
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
@use "@/colors" as c;

.route-loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2000;
  height: 3px;
  overflow: hidden;
}

.indicator {
  width: 100%;
  height: 100%;
  background-color: c.$blue;
  transform-origin: left;
  transition: transform 0.2s ease;
}

.route-loading-fade-enter-active,
.route-loading-fade-leave-active {
  transition: opacity 0.2s ease;
}

.route-loading-fade-enter-from,
.route-loading-fade-leave-to {
  opacity: 0;
}
</style>
